import actionTypes from "./actionTypes";
import * as manualsUtils from "../utils/manualsUtils";

const getManualRequest = () => ({
  type: actionTypes.GET_MANUAL_REQUEST,
});
const getManualSuccess = (res) => ({
  type: actionTypes.GET_MANUAL_SUCCESS,
  res,
});
const getManualFailure = (error) => ({
  type: actionTypes.GET_MANUAL_FAILURE,
  error,
});
export const getManual = () => {
  return async (dispatch) => {
    try {
      dispatch(getManualRequest());
      let res = await manualsUtils.getManual();
      dispatch(getManualSuccess(res));
    } catch (error) {
      dispatch(getManualFailure(error));
    }
  };
};
